import React from "react";
import { Link } from "react-router-dom";
import moment from "moment-timezone";
import Tooltip from "@mui/material/Tooltip";

import shortenName from "../../helpers/shorten-name";

const getMessagesColumns = (type) => ([
  {
    name: "Date / Time",
    selector: "timestamp",
    sortable: true,
    cell: (row) => {
      return moment(row.timestamp).format("M/D/YY - HHmm");
    },
    minWidth: "80px",
    maxWidth: "110px",
  },
  {
    name: "Trip #",
    selector: "tripTag",
    sortable: true,
    cell: (row) => {
      if (!row.tripId) {
        return "-";
      }

      return (
        <Link className="ellipsis-cell" to={`/trips/${row.tripId}`} target="_blank" rel="noopener noreferrer">
          <Tooltip title={row.tripTag} arrow>
            {row.tripTag}
          </Tooltip>
        </Link>
      );
    },
    width: "80px",
  },
  {
    name: "Lead",
    selector: "leadId",
    sortable: false,
    cell: (row) => {
      if (!row.leadId) {
        return "-";
      }

      return <Link to={`/leads/${row.leadId}`} target="_blank" rel="noopener noreferrer">
        <span className="material-icons">visibility</span>
      </Link>;
    },
    width: "50px",
  },
  {
    name: "Client",
    selector: "client",
    sortable: true,
    wrap: true,
    minWidth: "100px !important",
    width: "auto",
    maxWidth: "120px",
    cell: (row) => {
      return <div className="two-line-content">{row.client}</div>;
    },
  },
  {
    name: "Message",
    selector: "contents",
    wrap: true,
    minWidth: "220px !important",
    width: "auto",
    cell: (row) => {
      return <div className="two-line-content">{row.contents}</div>;
    },
  },
  type === "internal" ? {
    name: "Sent by",
    selector: "sentBy",
    sortable: true,
    wrap: true,
    minWidth: "80px",
    width: "auto",
    maxWidth: "100px",
    cell: (row) => shortenName(row.sentBy),
  } : null,
  {
    name: "Reply",
    width: "75px",
    cell: (row) => {
      if (row.tripId) {
        return <Link to={`/trips/${row.tripId}?tab=messages&messagesTab=${type}`} target="_blank" rel="noopener noreferrer">Reply</Link>;
      } else {
        return <Link to={`/leads/${row.leadId}?tab=messages&messagesTab=${type}`} target="_blank" rel="noopener noreferrer">Reply</Link>;
      }
    },
  },
].filter(Boolean));

const evoMessagesColumns = getMessagesColumns("internal");
const appMessagesColumns = getMessagesColumns("app");

export { evoMessagesColumns, appMessagesColumns };
